import React from 'react';
import './index.scss'

const DOT_COLORS = [
  null, '#3B7DD8', '#4B88DD', '#3F80D6', null,
  '#5580C0', '#6B80CC', '#6F85CC', '#7080C8', '#7885CC',
  '#1DB895', '#6680C4', '#7075C0', '#6A74BE', '#90A0D0',
  '#3580D8', '#5078C8', '#4C7CC4', '#35C4C8', '#A0B0D8',
  null, '#A0A8D4', '#B0B8E0', '#B5BDE4', null
];

function Loader() {
  return (
    <div className="loader-container" role="status" aria-live="polite" aria-label="Loading">
      <div className="loader-card">
        <div className="loader-dot-grid" aria-hidden="true">
          {DOT_COLORS.map((color, index) => (
            <span
              key={index}
              className={`loader-dot${color ? '' : ' loader-dot-empty'}`}
              style={color ? {
                backgroundColor: color,
                animationDelay: `${index * 0.12}s`,
              } : undefined}
            />
          ))}
        </div>
        {/* <div className="loader-copy">
          <div className="loader-title">Loading</div>
          <div className="loader-subtitle">Please wait while we prepare your data</div>
        </div> */}
      </div>
    </div>
  );
}

export default Loader;
